export default __webpack_public_path__ + "fonts/poppins-latin-400-normal.405055dd680fa1dcdfa2.woff2";